import { homedir } from "node:os";
import { join } from "node:path";
export const CONFIG_PATH = join(homedir(), ".hepha", "config.json");
